import * as React from 'react';
import { useParams } from 'react-router-dom';
import {Fragment, useEffect} from "react";
import Grid from "@mui/material/Grid";
import ReportEntry from "../reportEntry";
import Drawer from "@mui/material/Drawer";
import AppBar from '@mui/material/AppBar';
import CssBaseline from "@mui/material/CssBaseline";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import IconButton from "@mui/material/IconButton";
import { styled, alpha  } from '@mui/material/styles';
import {Chip} from "@mui/material";
import Box from "@mui/material/Box";
import authService from '../api-authorization/AuthorizeService'
import RandomQuote from "../randomQuote";
import {HelpText} from "../HelpText";
import SimpleBackdrop from "../backdrop";
import moment from 'moment';
import IssueList from "../issues/issuelist";
import Title from "../Title";
import Stack from "@mui/material/Stack";
import {CleaningServices, Update} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import ArchiveIcon from '@mui/icons-material/Archive';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import EditIcon from '@mui/icons-material/Edit';
import StyledActionButton from "../GreenButton";
import FormDialog from "./formdialog";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Alert from '@mui/material/Alert';
import CurrencyPoundIcon from '@mui/icons-material/CurrencyPound';
import MoneyIcon from '@mui/icons-material/Money';
import {link} from "@uiw/react-md-editor";
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import {StyledMenu} from "../styledMenu";
import CircularProgress from "@mui/material/CircularProgress";
import TablePagination from '@mui/material/TablePagination';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CloseIcon from '@mui/icons-material/Close';
import Skeleton from "@mui/material/Skeleton";
import SmartDisplayIcon from '@mui/icons-material/SmartDisplay';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import TelegramIcon from '@mui/icons-material/Telegram';
import PublicIcon from '@mui/icons-material/Public';



export default function ProjectDetails({updateTitle}) {

    const [ project, setProject] = React.useState({keywords:[]});
    const [reportDetails, setReportDetails] = React.useState({});

    const [ reports, setReports] = React.useState([]);
    const [ reviewedReports, setReviewedReports] = React.useState([]);
    const { id, entryId } = useParams();
    const [loading, setLoading] = React.useState(true);
    const [active, setActive] = React.useState(false);
    const [drawOpen, setdrawOpen] = React.useState(false);

    const [loadedReports, setLoadedReports] = React.useState(false);
    const [loadedReviewed, setLoadedReviewed] = React.useState(false);
    const [loadedProject, setLoadedProject] = React.useState(false);

    const [openScheduleReport, setOpenScheduleReport] = React.useState(false);
    const [scheduleReportLoading, setScheduleReportLoading] = React.useState(false);
    const [scheduleReportError, setScheduleReportError] = React.useState(null);
    const [scheduleReportRows, setScheduleReportRows] = React.useState([]);
    
    const [page, setPage] = React.useState(0);            // 0-based
    const [pageSize, setPageSize] = React.useState(25);
    const [total, setTotal] = React.useState(0);
    const [totalPages, setTotalPages] = React.useState(0);

    const cacheRef = React.useRef(new Map());
    const makeKey = (projId, size, reviewed) => `${projId}|${size}|${reviewed ? 1 : 0}`;

    const getBucket = (key) => cacheRef.current.get(key);
    const getCachedPage = (key, p) => {
        const b = cacheRef.current.get(key);
        return b?.pages?.get(p);
    };
    const putCachedPage = (key, resp) => {
        const existing = cacheRef.current.get(key) ?? { meta: {}, pages: new Map() };
        const pageIndex = resp.page ?? 0;
        existing.meta = {
            total: resp.total ?? existing.meta.total ?? 0,
            totalPages: resp.totalPages ?? existing.meta.totalPages ?? 0,
            pageSize: resp.pageSize ?? existing.meta.pageSize ?? 0,
        };
        existing.pages.set(pageIndex, resp.items ?? []);
        cacheRef.current.set(key, existing);
    };
    const clearProjectCache = (projId) => {
        const prefix = `${projId}|`;
        for (const k of Array.from(cacheRef.current.keys())) {
            if (k.startsWith(prefix)) cacheRef.current.delete(k);
        }
    };

    // Drip prefetch state
    const prefetchStateRef = React.useRef({
        running: false,
        projectId: null,
        size: null,
        next: 0,
        totalPages: 0,
    });

// Start/continue sequential prefetch: page-by-page until all cached
    const startDripPrefetch = (projId, size) => {
        const key = makeKey(projId, size, false);
        const bucket = getBucket(key);
        const totalPages = bucket?.meta?.totalPages ?? 0;
        if (!totalPages) return;

        // Seed "next" as the first missing page
        let firstMissing = 0;
        for (let p = 0; p < totalPages; p++) {
            if (!getCachedPage(key, p)) { firstMissing = p; break; }
            firstMissing = p + 1;
        }
        if (firstMissing >= totalPages) return;

        // If an identical job is already running and ahead of us, do nothing
        const st = prefetchStateRef.current;
        if (
            st.running &&
            st.projectId === projId &&
            st.size === size &&
            st.next <= firstMissing &&
            st.totalPages === totalPages
        ) return;

        // (Re)start the loop
        prefetchStateRef.current = {
            running: true,
            projectId: projId,
            size,
            next: firstMissing,
            totalPages
        };

        (async function loop() {
            // Run until stopped, project/size changes, or we’ve cached everything
            // IMPORTANT: never toggle UI loading here — this is background-only
            while (true) {
                const s = prefetchStateRef.current;
                if (!s.running || s.projectId !== projId || s.size !== size) break;
                if (s.next >= s.totalPages) { s.running = false; break; }

                const k = makeKey(projId, size, false);
                if (getCachedPage(k, s.next)) { s.next++; continue; }

                try {
                    const res = await fetch(
                        `/api/projects/details/${projId}/report?items=${size}&page=${s.next}&reviewed=false`
                    );
                    const data = await res.json();
                    putCachedPage(k, data);
                    s.next++;
                } catch {
                    // On failure, stop the chain (avoid hammering)
                    s.running = false;
                    break;
                }
            }
        })();
    };
    
    const stopDripPrefetch = () => { prefetchStateRef.current.running = false; };
    
    const fetchData = async (nextPage = page, nextSize = pageSize, { force = false } = {}) => {
        const key = makeKey(id, nextSize, false);

        // Serve instantly from cache
        if (!force) {
            const cached = getCachedPage(key, nextPage);
            if (cached) {
                const bucket = getBucket(key);
                setReports(cached);
                setPage(nextPage);
                setPageSize(nextSize);
                if (bucket?.meta) {
                    setTotal(bucket.meta.total ?? 0);
                    setTotalPages(bucket.meta.totalPages ?? 0);
                }
                // ✅ Kick/continue the drip after a cache hit
                startDripPrefetch(id, nextSize);
                return; // no network, no loading overlay
            }
        }

        // Not cached: show global backdrop and fetch
        setLoading(true);
        setLoadedReports(false);

        const res = await fetch(`/api/projects/details/${id}/report?items=${nextSize}&page=${nextPage}&reviewed=false`);
        const data = await res.json();

        setReports(data.items ?? []);
        setPage(data.page ?? nextPage);
        setPageSize(data.pageSize ?? nextSize);
        setTotal(data.total ?? 0);
        setTotalPages(data.totalPages ?? 0);
        setLoadedReports(true);

        // cache this page
        putCachedPage(key, data);

        setLoading(false);

        // ✅ Kick/continue the drip after a network fetch too
        startDripPrefetch(id, nextSize);
    };


    const fetchReviewedData = async () => {
        setLoadedReviewed(false);
        const res = await fetch(`/api/projects/details/${id}/report/reviewed`);
        const data = await res.json();
        setReviewedReports(data);
        setLoadedReviewed(true);
    };
    const fetchProjectData = async () => {
        setLoadedProject(false);
        const res = await fetch(`/api/projects/details/${id}`);
        const data = await res.json();
        setProject(data);
        updateTitle(data.name);
        setLoadedProject(true);
    };

    useEffect(() => {
        setLoading(true);
        stopDripPrefetch();        // stop any prior chain
        clearProjectCache(id);     // avoid stale pages when switching projects
        setPage(0);

        Promise.all([
            fetchData(0, pageSize, { force: true }), // loads page 0 (and starts drip)
            fetchReviewedData(),
            fetchProjectData()
        ]).finally(() => {setLoading(false);});
    }, [id]);
    
    const routeOpenIdRef = React.useRef(null);
    const didOpenFromRouteRef = React.useRef(false);
    React.useEffect(() => {
        routeOpenIdRef.current = entryId ? String(entryId) : null;
    }, [entryId]);
    const fetchEntryById = async (projectId, entryId) => {
        const res = await fetch(`/api/projects/details/${projectId}/report/${entryId}`);
        authService.followIfLoginRedirect(res);
        if (!res.ok) return null;
        const data = await res.json();
        // API might return a single object or an array; normalize:
        return Array.isArray(data) ? data[0] : data;
    };
    const isReviewedEntry = (e) =>
        !!(e.reviewed || e.is_reviewed || e.resolved || e.status === 'reviewed' || e.status === 'resolved');


    const appendUnique = (arr, item) => {
        const idStr = String(item.report_entry_id);
        return Array.isArray(arr) && arr.some(x => String(x.report_entry_id) === idStr)
            ? arr
            : [...(arr || []), item];
    };

    React.useEffect(() => {
        if (didOpenFromRouteRef.current) return;          // already handled
        if (!routeOpenIdRef.current) return;              // no deep-link
        if (loading) return;                              // still loading your main lists

        const idToOpen = routeOpenIdRef.current;
        const byId = (arr) => Array.isArray(arr)
            ? arr.find(x => String(x.report_entry_id) === idToOpen)
            : null;

        const found = byId(reports) || byId(reviewedReports);
        if (found) {
            didOpenFromRouteRef.current = true;
            routeOpenIdRef.current = null;
            updateDetails(found);
            return;
        }

        // Not found – fetch just this entry, append, then open
        (async () => {
            setLoading(true);
            const entry = await fetchEntryById(id, idToOpen);
            if (!entry) {
                setLoading(false);
            };

            if (isReviewedEntry(entry)) {
                setReviewedReports(prev => appendUnique(prev, entry));
            } else {
                setReports(prev => appendUnique(prev, entry));
            }

            didOpenFromRouteRef.current = true;
            routeOpenIdRef.current = null;
            updateDetails(entry);
            setLoading(false);
        })().catch(console.error);
    }, [reports, reviewedReports, loading, id]);

    const getUniqueOrganisationBrands = (urls) => {
    const uniqueBrands = new Set();

    let linksFound = false
    urls.forEach(urlObj => {
        if (urlObj.brands && Array.isArray(urlObj.brands)) {
            urlObj.brands.forEach(brand => {
                if (brand.organisation_brand && brand.organisation_brand.name) {
                    uniqueBrands.add(brand.organisation_brand.name);
                    if(!linksFound){
                        if(brand.redirects === true || brand.dest_page === true || brand.link === true){
                            linksFound = true
                        }
                    }
                }
            });
        }
    });

    return {brands: Array.from(uniqueBrands), linksFound: linksFound}
};
   
    
    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setdrawOpen(open);
    };
    const updateDetails = (v) => {
        console.log(v);
        //debugger;
        
        toggleDrawer(true);
     
        setReportDetails(v);
        setdrawOpen(true);
       

        fetch('/api/projects/details/' + id + "/report/viewed/" + v.report_entry_id
            , {
            //headers: !token ? {} : {'X-Authorization': `Bearer ${token}`} }
        }).catch(console.log);
        v.viewed = true;
    };

    const styles = {
        navBar: {'top': AppBar.height}
    }
    const drawerWidth = "30em";
    
 

    const DrawerHeader = styled('div')(({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-start',
    }));

    const noEntries = () => {
        return (
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                <Box sx={{my:{xs:3, md:5}}}>
                    <Typography variant={"h5"} align={"center"}>Nothing here! </Typography>
                    <Typography align={"center"} sx={{mx:10, mt:5}}>This project has no content needing a review right now, come back later.</Typography>
                </Box>
            </Paper>
        )
    }

   
    const editCallback = () => {
        fetchProjectData().catch(console.log).finally(() => setLoading(false))
        setHandleEdit(false);
    };
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const [handleEditMode, setHandleEdit] = React.useState(false);
    const handleEdit = () => {
        setAnchorEl(null);
        setHandleEdit(true);
    };

    const [handleArchiveMode, setArchiveMode] = React.useState(false);
    
    const handleArchive = () => {
        setAnchorEl(null);
        setArchiveMode(true);
    };
    const handleArchiveClose = () => {
        setAnchorEl(null);
        setArchiveMode(false);
        
    };

    const [openConfirmAll, setOpenConfirmAll] = React.useState(false);

    const handleClickOpenConfirmAll = () => {
        setOpenConfirmAll(true);
    };

    const [loadingConfirmAll, setLoadingConfirmAll] = React.useState(false);

    const handleCloseConfirmAll = () => {
        if (!loadingConfirmAll) {
            setOpenConfirmAll(false);
        }
    };

    const doNoIssueAllProcessing = async () => {
        const response = await fetch('/api/issues/projects/' + id + '/issues/no_issue_all', {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({})
        });
        authService.followIfLoginRedirect(response);

        clearProjectCache(id);                  // NEW: invalidate
        await fetchData(0, pageSize, { force: true }); // reload first page
        fetchProjectData().catch(console.error);
        fetchReviewedData().catch(console.error);
    };

    const doNoIssueAll = async () => {
        setLoadingConfirmAll(true);
        try {
            // Call your async action here
            await doNoIssueAllProcessing();  // Replace this with your real function
            setOpenConfirmAll(false);
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoadingConfirmAll(false);
        }
    };
    
    const confirmDoArchive = async () => {
      console.log('archive');
        setLoading(true);
        //const token = await authService.getAccessToken();
        const response = await fetch('/api/projects/' + project.id + '/archive', {
            method: "PUT"
            //headers: !token ? {} : {'X-Authorization': `Bearer ${token}`} }
        });
        editCallback();
        setLoading(false);
        setAnchorEl(null);
        setArchiveMode(false);
    };

    const openScheduleReportModal = async () => {
        setAnchorEl(null); // close menu
        setOpenScheduleReport(true);

        // If already loaded once and you don't want to refetch every time, you can early-return here:
        // if (scheduleReportRows && scheduleReportRows.length > 0) return;

        setScheduleReportLoading(true);
        setScheduleReportError(null);

        try {
            const res = await fetch(`/api/projects/${id}/posting-schedule/verification`);
            authService.followIfLoginRedirect(res);

            if (!res.ok) {
                throw new Error(`Failed to load schedule report (${res.status})`);
            }

            const data = await res.json();
            setScheduleReportRows(Array.isArray(data) ? data : []);
        } catch (e) {
            console.error(e);
            setScheduleReportError(e?.message || "Failed to load schedule report.");
            setScheduleReportRows([]);
        } finally {
            setScheduleReportLoading(false);
        }
    };

    const closeScheduleReportModal = () => {
        setOpenScheduleReport(false);
    };

    const getEntryTitle = (row) => {
        const title = row?.media?.video_title?.trim();
        const fallbackDescription = row?.media?.video_description?.trim() || row?.description_at_report?.trim();
        return title || fallbackDescription || "(No title or description)";
    };

    const getEntryDescription = (row) => {
        const description = row?.media?.video_description?.trim() || row?.description_at_report?.trim();
        const title = row?.media?.video_title?.trim();
        if (!description || description === title) return null;
        return description.length > 110 ? `${description.substring(0, 110)}...` : description;
    };

    const getChannelTypeIcon = (channelType) => {
        const t = (channelType || "").toLowerCase();
        if (t.includes("youtube")) return <SmartDisplayIcon fontSize="small" color="error" />;
        if (t.includes("tiktok")) return <MusicNoteIcon fontSize="small" color="action" />;
        if (t.includes("twitch")) return <SportsEsportsIcon fontSize="small" color="action" />;
        if (t.includes("telegram")) return <TelegramIcon fontSize="small" color="primary" />;
        return <PublicIcon fontSize="small" color="disabled" />;
    };
    
    const entriesTable = (reports2) => {
        return (
            <TableContainer component={Paper}>
                {(reports2 && reports2.length > 0) && (<Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{width:"20px"}}></TableCell>
                            <TableCell>Video</TableCell>
                            <TableCell>Channel</TableCell>
                            <TableCell>Platform</TableCell>
                            <TableCell sx={{minWidth:170}} >Date</TableCell>
                            {/*<TableCell >Report Entires</TableCell>
                                <TableCell >Views</TableCell>
                                <TableCell >Duration (s)</TableCell>
                                <TableCell>Labels</TableCell>*/}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {reports2.map((row) => {
                            let brandsInContent = row.brand_matches && row.brand_matches.length > 0;
                            let linksInContent = row.brand_matches && row.brand_matches.filter(e=>e.links_redirects === true || 
                            e.links_dest_links === true || e.links_url === true).length > 0;
                            let visualInContent = row.brand_matches && row.brand_matches.filter(e=>e.visual_matches === true).length > 0;
                            const channelType = row?.media?.channel?.channel_type;
                            const channelHandle = row?.media?.channel?.handle || "(unknown)";
                           return (
                            <TableRow
                                hover
                                key={row.report_entry_id}
                                onClick={(event) =>updateDetails(row)}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer' }}
                            >
                                <TableCell>
                                    {(row?.media?.channel?.videos?.[0]?.aff_evidence_exists || brandsInContent || linksInContent || visualInContent) && (

                                        <BusinessCenterIcon color={brandsInContent && linksInContent && visualInContent ? "error" : "warning"} sx={{opacity:0.7}}/>

                                    )}
                                </TableCell>
                                <TableCell scope="row"
                                           style={{fontWeight: (!row.viewed || row.viewed === false) ? "bold" : "normal"}}
                                >
                                        
                                        <span>{getEntryTitle(row)}</span>
                                        {getEntryDescription(row) && (
                                            <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary' }}>
                                                {getEntryDescription(row)}
                                            </Typography>
                                        )}
                                
                                </TableCell>

                                <TableCell>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        {getChannelTypeIcon(channelType)}
                                        <span>{channelHandle}</span>
                                    </Stack>
                                </TableCell>
                                <TableCell>{channelType || "-"}</TableCell>
                                <TableCell>{moment(row.date_created).format('DD MMM, HH:mm')}</TableCell>
                                {/*<TableCell align="right">{row.report_entries.length}</TableCell>
                                    <TableCell align="right">{row.media.views}</TableCell>
                                    <TableCell align="right">{row.media.duration}</TableCell>
                                    <TableCell>{row.visual_labels.length}</TableCell>*/}
                            </TableRow>
                        )})}
                    </TableBody>
                </Table>)}
                <TablePagination
                    component="div"
                    count={total}                    // total rows across all pages
                    page={page}                      // 0-based
                    onPageChange={(_, newPage) => fetchData(newPage, pageSize)}
                    rowsPerPage={pageSize}
                    onRowsPerPageChange={(e) => {
                        const newSize = parseInt(e.target.value, 10);
                        setPage(0);
                        fetchData(0, newSize);
                    }}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                />
            </TableContainer>        
        )
    }
    return (
        <div>
            {handleEditMode && <FormDialog show={handleEditMode} existing={project} cb={editCallback } />}
            <Stack component="div" alignItems={"center"}>
                <StyledActionButton
                    id="demo-customized-button"
                    aria-controls={open ? 'demo-customized-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    variant="contained"
                    disableElevation
                    onClick={handleClick}
                    endIcon={<KeyboardArrowDownIcon />}
                    sx={{fontSize:14}}
                >
                    Options
                </StyledActionButton>
                <StyledMenu
                    id="demo-customized-menu"
                    MenuListProps={{
                        'aria-labelledby': 'demo-customized-button',
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    <MenuItem onClick={openScheduleReportModal} disableRipple>
                        <AssessmentIcon />
                        Posting schedule report
                    </MenuItem>

                    <Divider sx={{ my: 0.5 }} />
                    <MenuItem onClick={handleEdit} disableRipple>
                        <EditIcon />
                        Edit
                    </MenuItem>

                    {project.pending_items > 0 && (<MenuItem onClick={handleClickOpenConfirmAll} disableRipple>
                        <CleaningServices />
                        Mark all video no issue
                    </MenuItem>)}
                    <Divider sx={{ my: 0.5 }} />
                    <MenuItem onClick={handleArchive} disableRipple>
                        <ArchiveIcon />
                        Archive
                    </MenuItem>
                </StyledMenu>
               {project.project_status === 1 && (
                    <Stack sx={{pt:2}} alignItems={"center"}>
                        <Alert severity="warning">
                        <Typography>This project is archived.</Typography>
                        <Typography sx={{fontSize:12}}>{project.archived_by.display_name} archived it on {moment(project.date_project_archived).format('llll')}</Typography>
                        </Alert>
                    </Stack>
                )}
            </Stack>
            {project.keywords &&
                project.keywords.version === "1" &&
                project.keywords.keywords?.length > 0 && (
                    <Box component="div">
                        <Title>Project keywords</Title>
                        <Stack direction="row" spacing={1} flexWrap="wrap">
                            {project.keywords.keywords.map((row, idx) => (
                                <Chip label={row.keyword} key={idx} sx={{ mb: 2 }} />
                            ))}
                        </Stack>
                    </Box>
                )}

            {project.open_issues && project.open_issues.length > 0 && (
                <Box component="div" sx={{mt: 3, mb: 2}}>
                    <Title>Issues related to this project</Title>
                    <IssueList issues={project.open_issues} showadvanced={true} />
                </Box>
            )}
            
            <Grid
                container
                direction="row"
                sx={{mt: 3, mb: 2}}
            >
                <Title>Unreviewed project entries</Title>

                {(!loading && (!reports || reports.length === 0)) && (noEntries())}
                
                {(!loading && (reports && reports.length > 0)) && entriesTable(reports)}


            </Grid>

            <Grid
                container
                direction="column"
                sx={{mt: 3, mb: 2}}
            >


                    
                        <Title>Reviewed project entries</Title>
                        <Box><Typography>Up to the last 15 items which are reviewed and resolved.</Typography></Box>
                        {(!loading && (reviewedReports && reviewedReports.length > 0)) && entriesTable(reviewedReports)}
                <Stack direction={"column"} spacing={1} w2></Stack>
         
            </Grid>
            
            <Fragment>
            <CssBaseline />
            <Drawer

                sx={{
                    zIndex: 1000,
                    width: {xs:'100%', md:"65%"},
                    [`& .MuiDrawer-paper`]: {
                        width: {xs:'100%', md:"65%"},
                    },
                }}
                anchor='right'
                open={drawOpen} containerStyle={styles.navBar}
                onClose={toggleDrawer(false)}
            >
                <DrawerHeader>
                    <IconButton onClick={toggleDrawer(false)}>
                        <ChevronLeftIcon />  
                    </IconButton>
                    <strong>Video Review: &nbsp;</strong>
                    {project.name}
                </DrawerHeader>
                <Typography sx={{p:1, fontSize:16}} component="h6" variant="h6" >{reportDetails.title_at_report}</Typography>
                <Divider />
                <Box sx={{p:1}}>
                    <ReportEntry report={reportDetails} project={project} />
                </Box>
            </Drawer>
                </Fragment>

            <HelpText>
                The entities show above have matched in a search for a variable in the project keyword. Most likely, a 
                keyword. The entities shown above have not yet been reviewed and marked as having an issue or no issue.
                
                You can click a different button above to show entities which have been previously reviewed.

                Projects <strong>in bold</strong> are viewed by you or somebody in your team, but not actioned.
                <Divider sx={{my:3}}/>
                <Stack spacing={2}>
                    <Stack direction={"row"} spacing={2}>
                        <BusinessCenterIcon color={"error"} sx={{opacity:0.7}}/>
                        <Box>Video contains a keyword, a link and a logo or visual asset. These are your most significant items.</Box>
                    </Stack>
                   <Stack direction={"row"}  spacing={2}>
                       <BusinessCenterIcon color={"warning"} sx={{opacity:0.7}}/>
                       <Box>Video contains a keyword and either a link or a logo or visual asset. These are using your brand in some ways.</Box>
                   </Stack>
                </Stack>
            </HelpText>

            <Dialog
                open={handleArchiveMode}
                onClose={handleArchiveClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title">
                    {"Archive this project?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Archiving a project retains its data but does not delete it. You can unarchive a project at any time but while it is archived, it will not be updated.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleArchiveClose} sx={{color:'#279100'}}>
                        No, and cancel
                    </Button>
                    <Button onClick={confirmDoArchive} sx={{color:'red'}}>
                        Yes, archive this project
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openConfirmAll}
                onClose={handleCloseConfirmAll}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Mark all videos in this project as no issue?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        All videos will be marked as no issue. Your name will be assigned to this. No issue means 
                        that you have validated that the reported videos contain no problems and you have no further work
                        to do with them
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseConfirmAll} disabled={loading}>
                        Disagree
                    </Button>
                    <Button
                        onClick={doNoIssueAll}
                        autoFocus
                        disabled={loadingConfirmAll}
                        startIcon={loadingConfirmAll && <CircularProgress size={16} />}
                    >
                        {loadingConfirmAll ? 'Processing...' : 'Agree'}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openScheduleReport}
                onClose={closeScheduleReportModal}
                fullWidth
                maxWidth="lg"
            >
                <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    Posting schedule report
                    <IconButton onClick={closeScheduleReportModal} size="small" aria-label="close">
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    {/* ---------- Schedule header bar (single line) ---------- */}
                    {!scheduleReportLoading && !scheduleReportError && (
                        <Paper variant="outlined" sx={{ p: 1.5, mb: 2 }}>
                            {(() => {
                                const first = (scheduleReportRows && scheduleReportRows[0]) ? scheduleReportRows[0] : null;

                                const scheduleLabel =
                                    !first
                                        ? "-"
                                        : first.scheduleType === 0
                                            ? "ALL (every video must be reported)"
                                            : first.scheduleType === 1
                                                ? `Every ${first.scheduleThreshold} videos`
                                                : first.scheduleType === 2
                                                    ? `Every ${first.scheduleThreshold} days`
                                                    : "Unknown";

                                const startLabel = first?.postingScheduleStartDateUtc
                                    ? moment(first.postingScheduleStartDateUtc).format("DD MMM YYYY")
                                    : "-";

                                const total = (scheduleReportRows || []).length;
                                const compliant = (scheduleReportRows || []).filter(r => !!r.isCompliant).length;
                                const nonCompliant = total - compliant;
                                const noVideosSinceStart = (scheduleReportRows || []).filter(r => r.statusLabel === "NO_VIDEOS_SINCE_START").length;

                                return (
                                    <Stack
                                        direction={{ xs: "column", md: "row" }}
                                        spacing={1}
                                        alignItems={{ xs: "flex-start", md: "center" }}
                                        justifyContent="space-between"
                                    >
                                        <Stack direction="row" spacing={1} flexWrap="wrap" alignItems="center">
                                            <Chip size="small" label={`Schedule: ${scheduleLabel}`} />
                                            <Chip size="small" variant="outlined" label={`Start: ${startLabel}`} />
                                        </Stack>

                                        <Stack direction="row" spacing={1} flexWrap="wrap" alignItems="center">
                                            <Chip size="small" variant="outlined" label={`Channels: ${total}`} />
                                            <Chip size="small" color="success" label={`Compliant: ${compliant}`} />
                                            <Chip size="small" color="error" label={`Non-compliant: ${nonCompliant}`} />
                                            {noVideosSinceStart > 0 && (
                                                <Chip size="small" color="warning" label={`No videos since start: ${noVideosSinceStart}`} />
                                            )}
                                        </Stack>
                                    </Stack>
                                );
                            })()}
                        </Paper>
                    )}

                    {/* ---------- Report table (2-row layout per channel) ---------- */}
                    {!scheduleReportLoading && !scheduleReportError && (
                        <TableContainer component={Paper} variant="outlined">
                            <Table size="small" aria-label="posting schedule report table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ width: 260 }}>Channel</TableCell>
                                        <TableCell>Activity</TableCell>
                                        <TableCell align="right" sx={{ width: 100 }}>Videos (30d)</TableCell>
                                        <TableCell sx={{ width: 160 }}>Status</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {(scheduleReportRows || []).map((row) => {
                                        const compliant = !!row.isCompliant;

                                        const statusColor =
                                            row.statusLabel === "NO_VIDEOS_SINCE_START"
                                                ? "warning"
                                                : compliant
                                                    ? "success"
                                                    : "error";

                                        const lastVideoTime = row.lastVideoPublishedUtc
                                            ? moment(row.lastVideoPublishedUtc).format("DD MMM, HH:mm")
                                            : "-";

                                        const lastReportedTime = row.lastProjectReportEntryDateUtc
                                            ? moment(row.lastProjectReportEntryDateUtc).format("DD MMM, HH:mm")
                                            : "-";

                                        const lastEvidence = [];
                                        if (row.lastReportedFoundInTitle) lastEvidence.push("Title");
                                        if (row.lastReportedFoundInDescription) lastEvidence.push("Desc");
                                        if (row.lastReportedFoundInLinks) lastEvidence.push("Links");
                                        if (row.lastReportedFoundVisually) lastEvidence.push("Visual");

                                        const es = row.evidenceSummary || {};

                                        return (
                                            <Fragment key={row.projectChannelId}>
                                                {/* Row 1: compact summary */}
                                                <TableRow hover>
                                                    <TableCell>
                                                        <Typography sx={{ fontWeight: 700 }}>{row.handle}</Typography>
                                                        <Typography variant="caption" color="text.secondary">
                                                            {row.channelId}
                                                        </Typography>
                                                    </TableCell>

                                                    <TableCell>
                                                        <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                                                            Last video:
                                                            <span style={{ fontWeight: 400 }}> {row.lastVideoTitle || "-"}</span>
                                                        </Typography>
                                                        <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
                                                            {lastVideoTime}
                                                        </Typography>

                                                        <Box sx={{ mt: 1 }}>
                                                            <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                                                                Last reported:
                                                                <span style={{ fontWeight: 400 }}> {row.lastReportedVideoTitle || "-"}</span>
                                                            </Typography>
                                                            <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
                                                                {lastReportedTime}
                                                            </Typography>
                                                        </Box>
                                                    </TableCell>

                                                    <TableCell align="right">
                                                        {Number.isFinite(row.videosLast30Days) ? row.videosLast30Days : "-"}
                                                    </TableCell>

                                                    <TableCell>
                                                        <Chip
                                                            size="small"
                                                            color={statusColor}
                                                            label={row.statusLabel || (compliant ? "OK" : "NON_COMPLIANT")}
                                                        />
                                                        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1 }}>
                                                            Reported: {row.reportedVideosSinceStart ?? 0} / {row.totalVideosSinceStart ?? 0}
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>

                                                {/* Row 2: evidence + details (spans the table) */}
                                                <TableRow>
                                                    <TableCell colSpan={4} sx={{ bgcolor: "background.default" }}>
                                                        <Stack
                                                            direction={{ xs: "column", md: "row" }}
                                                            spacing={2}
                                                            alignItems={{ xs: "flex-start", md: "center" }}
                                                            justifyContent="space-between"
                                                        >
                                                            {/* Evidence: last + totals */}
                                                            <Box>
                                                                <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>
                                                                    Evidence (last reported)
                                                                </Typography>

                                                                <Stack direction="row" spacing={1} flexWrap="wrap">
                                                                    {lastEvidence.length > 0 ? (
                                                                        lastEvidence.map((e) => (
                                                                            <Chip key={e} size="small" variant="outlined" label={e} />
                                                                        ))
                                                                    ) : (
                                                                        <Chip size="small" variant="outlined" label="No last evidence" />
                                                                    )}
                                                                </Stack>

                                                                <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1, mb: 0.5 }}>
                                                                    Evidence totals (since start)
                                                                </Typography>

                                                                <Stack direction="row" spacing={1} flexWrap="wrap">
                                                                    <Chip size="small" label={`Title ${es.videosWithTitleEvidence || 0}`} />
                                                                    <Chip size="small" label={`Desc ${es.videosWithDescriptionEvidence || 0}`} />
                                                                    <Chip size="small" label={`Links ${es.videosWithLinksEvidence || 0}`} />
                                                                    <Chip size="small" label={`Visual ${es.videosWithVisualEvidence || 0}`} />
                                                                </Stack>
                                                            </Box>

                                                            {/* Details + metrics */}
                                                            <Box sx={{ minWidth: 260 }}>
                                                                <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
                                                                    Details
                                                                </Typography>
                                                                <Typography sx={{ fontSize: 13 }}>
                                                                    {row.details || "-"}
                                                                </Typography>

                                                                <Stack direction="row" spacing={2} sx={{ mt: 1 }} flexWrap="wrap">
                                                                    {row.maxConsecutiveUnreportedVideos != null && (
                                                                        <Typography variant="caption" color="text.secondary">
                                                                            Max consecutive unreported: {row.maxConsecutiveUnreportedVideos}
                                                                        </Typography>
                                                                    )}
                                                                    {row.maxDaysBetweenReportedVideos != null && (
                                                                        <Typography variant="caption" color="text.secondary">
                                                                            Max days between reported: {row.maxDaysBetweenReportedVideos}
                                                                        </Typography>
                                                                    )}
                                                                </Stack>
                                                            </Box>
                                                        </Stack>
                                                    </TableCell>
                                                </TableRow>
                                            </Fragment>
                                        );
                                    })}

                                    {(!scheduleReportRows || scheduleReportRows.length === 0) && (
                                        <TableRow>
                                            <TableCell colSpan={4}>
                                                <Typography align="center" sx={{ py: 3 }} color="text.secondary">
                                                    No channels found for this project.
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}

                </DialogContent>

                <DialogActions>
                    <Button onClick={closeScheduleReportModal}>Close</Button>
                    <Button
                        onClick={openScheduleReportModal}
                        disabled={scheduleReportLoading}
                        startIcon={scheduleReportLoading ? <CircularProgress size={16} /> : null}
                    >
                        Refresh
                    </Button>
                </DialogActions>
            </Dialog>

            <SimpleBackdrop  open={loading}/>
        </div>
    );
}
